import styled from 'styled-components';
import {JACKPOTS_ITEM, LIVE_STREAMING_ITEM, STATIC_VIDEO_ITEM} from '../../../../themes/css-global-classes';

export const SwiperWrapperDefaultBox = styled.div`
    position: relative;
    width: 100%;
    padding: 0;
    margin: 0 auto;
    overflow: hidden;

    @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
        &.${JACKPOTS_ITEM} {
            width: 100%;
        }

        &.${LIVE_STREAMING_ITEM},
        &.${STATIC_VIDEO_ITEM} {
        width: 104%;
        padding-bottom: 2.5rem;
        padding-top: 1.5rem;
        margin-left: -2%;
        clipPath: polygon(8% 0, 92% 0%, 92% 100%, 8% 100%);
        overflow: unset;
        }
    }
`;
